import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

/** Plazo legal fijo acordado: 180 días corridos desde la fecha de ingreso (día civil UTC). */
export const RESPEL_LEGAL_WINDOW_DAYS = 180;

const THRESHOLD_SUCCESS_MIN = 30;
const THRESHOLD_WARNING_MIN = 8;

const BADGE_BASE = 'badge-table badge badge-label';

/**
 * Último día inclusive del plazo (mismo criterio que `add(180, 'day')` desde inicio del día de ingreso).
 * @param {string|Date|number|import('dayjs').Dayjs} intakeDate
 * @returns {import('dayjs').Dayjs | null}
 */
export function getRespelIntakeDueDateUtc(intakeDate) {
	const start = dayjs.utc(intakeDate);
	if (!start.isValid()) return null;
	return start.startOf('day').add(RESPEL_LEGAL_WINDOW_DAYS, 'day');
}

/**
 * Días restantes hasta `dueDate` (inclusive): 0 si hoy es el último día del plazo.
 * @param {string|Date|number|import('dayjs').Dayjs} intakeDate
 * @param {import('dayjs').Dayjs} [nowUtc=dayjs.utc()]
 * @returns {number | null}
 */
export function getRespelIntakeDaysRemainingUtc(
	intakeDate,
	nowUtc = dayjs.utc(),
) {
	const due = getRespelIntakeDueDateUtc(intakeDate);
	if (!due) return null;
	const today = dayjs.utc(nowUtc).startOf('day');
	const dueDay = due.startOf('day');
	return dueDay.diff(today, 'day');
}

/**
 * Clases Bootstrap alineadas a la columna Plazo en guías (`GuidesListTab`).
 * @param {number | null} daysRemaining
 * @returns {string | null}
 */
export function getRespelIntakeExpiryBadgeClass(daysRemaining) {
	if (daysRemaining === null || daysRemaining === undefined) return null;
	if (Number.isNaN(daysRemaining)) return null;
	if (daysRemaining > THRESHOLD_SUCCESS_MIN) {
		return `${BADGE_BASE} bg-success`;
	}
	if (daysRemaining >= THRESHOLD_WARNING_MIN) {
		return `${BADGE_BASE} bg-warning`;
	}
	return `${BADGE_BASE} bg-danger`;
}

/**
 * Etiqueta `DD-MM-YYYY` del último día del plazo (UTC).
 * @param {string|Date|number|import('dayjs').Dayjs} intakeDate
 * @returns {string | null}
 */
export function formatRespelIntakeDueDateLabel(intakeDate) {
	const due = getRespelIntakeDueDateUtc(intakeDate);
	if (!due) return null;
	return due.format('DD-MM-YYYY');
}

/**
 * Formatea `worst_legal_due_date` ISO devuelto por el API de stock.
 * @param {string|Date|number|import('dayjs').Dayjs|null|undefined} isoDate
 * @returns {string | null}
 */
export function formatDueDateLabelFromIso(isoDate) {
	if (isoDate === null || isoDate === undefined || isoDate === '') {
		return null;
	}
	const due = dayjs.utc(isoDate);
	if (!due.isValid()) return null;
	return due.format('DD-MM-YYYY');
}
